import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d1390454"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1390454')) {
      api.createRecord('d1390454', component.options)
    } else {
      api.reload('d1390454', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d1390454", function () {
      api.rerender('d1390454', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/contact/index.vue"
export default component.exports